/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../util/DashboardFormatter'
], function(Formatter) {

	// implements IFormatter
	class VIPRFormatter {
		constructor(slotIndex, dataItemIndex, context) {
			if (context.index.dataItemFormats !== undefined) {
				this._format = context.index.dataItemFormats[dataItemIndex];
			} else {
				const slot = context.dataset.slots[slotIndex];
				const dataItem = slot.getDataItemList()[dataItemIndex];
				this._format = dataItem.getFormat();
			}
		}

		getFormat() {
			return this._format;
		}

		format(value) {
			return Formatter.format(value, this._format);
		}
	}

	return VIPRFormatter;
});